import { makeStyles } from '@mui/styles';
import { Progress, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';

import { ticketHttp } from '@network';
import { SupportTicket } from '@types';
import { InitialCard } from '@components';

interface Props {
  setLoader: (num: number, value: boolean) => void;
}

export const PendingTickets = ({ setLoader }: Props) => {
  const [numbers, setNumbers] = useState<SupportTicket[]>([]);
  const cls = useStyles();

  const loadNumbers = async () => {
    setLoader(10, true);
    try {
      const nextNumbers = await ticketHttp.getTicketList();
      setNumbers(nextNumbers.length ? nextNumbers.filter(i => i.status === 'pending') : []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoader(10, false);
    }
  };

  useEffect(() => void loadNumbers(), []);

  if (!numbers) {
    return null;
  }

  const counter = numbers.length || 0;
  const strokeColor = '#042E6B';

  return (
    <InitialCard
      center="Pending Tickets"
      extraPadding fullHeight
      contentClass={cls.content}
      left={<div/>}
      right={
        <Tooltip title="Not affected by time filter" placement="left" color="#042E6B">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#F38336">
            <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 27-3 53t-10 51q-14-16-32.5-27T794-418q3-15 4.5-30.5T800-480q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93q51 0 97.5-15t85.5-42q12 17 29.5 30t37.5 20q-51 41-114.5 64T480-80Zm290-160q-21 0-35.5-14.5T720-290q0-21 14.5-35.5T770-340q21 0 35.5 14.5T820-290q0 21-14.5 35.5T770-240Zm-158-52L440-464v-216h80v184l148 148-56 56Z"/>
          </svg>
        </Tooltip>
      }
    >
      <Progress
        type="circle"
        width={190}
        percent={100}
        style={{ marginTop: 45 }}
        strokeColor={strokeColor}
        trailColor={'black'}
        format={() => <span className={cls.counter}>{counter}</span>}
      />
    </InitialCard>
  );
};

const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  counter: {
    marginTop: 5,
    fontSize: 40,
    fontWeight: 600,
    color: 'var(--title-color)',
  },
});
